export const versions = [
  {
    id: "theatrical",
    type: "院线版",
    desc: "发行方为通过分级、适配排片与大众市场而确定的版本，通常节奏更紧凑，部分直接场面会被剪短或淡化。",
    diff: "时长最短，叙事最集中，但不一定最贴近导演初衷。",
  },
  {
    id: "director",
    type: "导演剪辑版",
    desc: "由导演重新把关完成的版本，补回院线版删减的段落，人物动机往往因此更连贯，情绪铺垫也更充分。",
    diff: "常在结尾或关键关系转折处与院线版有明显差别。",
  },
  {
    id: "extended",
    type: "延长版",
    desc: "在院线版基础上追加拍过的素材，增加生活细节与次要线索，篇幅明显拉长，观感更接近「陪着角色生活」。",
    diff: "节奏更慢，适合已经喜欢该片的观众二刷。",
  },
  {
    id: "regional",
    type: "地区版本",
    desc: "不同国家的分级制度不同，同一部影片可能出现德国版、日本版等多种剪辑，画面与时长都可能不一致。",
    diff: "选择播放源时容易遇到版本混淆，需留意时长。",
  },
];